import React, {FunctionComponent, useRef, useEffect} from 'react';
import { connect } from 'react-redux';
import { getUAMBusinessFunctions, setUser, getUserUamPermission } from 'actions/user';
import { detectAuthStatus } from 'actions/auth';
import { fetchFeatureToggles} from 'actions/featureToggle'
import { authentication, acquireToken } from './authentication';
import { getNickName } from 'actions/nickname';
import { LoadingAnimation } from 'components/loading';
import { CONFIG } from 'configs/index';
import { IStore } from 'reducers/index';
import { IRoles } from 'utilities/roles';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { User } from 'msal';
import * as mainRoutes from 'constants/routes';


interface IMapStateToProps {
    signedIn: boolean;
    roles: IRoles[]
}

interface IDispatch {
    user: (user: User) => void;
    getNickName: (token:any) => void;
    getUserUamPermission: () => void;
    setAuthenticateStatus: () => void;
    getUAMBusinessFunctions: () => void;
    fetchFeatureToggles: () => void;
}

interface IMsal extends IDispatch, IMapStateToProps {};

const Msal: FunctionComponent<IMsal> = (props) => {
    const isInitialMount = useRef<boolean>(true);
    useEffect(() => {
        const storedData:any = localStorage.getItem('expiry-date')
        if(!storedData || (storedData && isNaN(storedData))|| (storedData && new Date().getTime()>Number(storedData))){
            localStorage.clear();
            localStorage.setItem('expiry-date', JSON.stringify(new Date().getTime() + 43200000));
            location.reload()
        }
        if (isInitialMount.current) {
            isInitialMount.current = false;
            authentication.initialize(CONFIG.MSAL);
            acquireToken(props.setAuthenticateStatus);
            authentication.setAuthorizationInterceptors();
        } else {
            props.getNickName(authentication.getAccessToken());
            props.getUserUamPermission();
            if(props.signedIn) {
                props.user(authentication.getUser());
                if(props.roles.length === 0 || props.roles[0] as any === 'No permissions'){
                    props.getUAMBusinessFunctions();
                }
                props.fetchFeatureToggles();
            } else {
                location.replace(mainRoutes.OTHER_ROUTES.UNAUTHORIZED)
                authentication.signOut();
            }
        }
    }, [props.signedIn]);

    if(props.signedIn) {
        return(
            <React.Fragment>
                {props.children}
            </React.Fragment>
        )
    }
    return <LoadingAnimation />;
}

const mapStateToProps = (state: IStore): IMapStateToProps => ({
    signedIn: state.auth.signedIn,
    roles: state.user.roles
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IDispatch => ({
    user: (user: User) => dispatch(setUser(user)),
    getNickName: (token: any) => dispatch(getNickName(token)),
    getUserUamPermission: () => dispatch(getUserUamPermission()),
    setAuthenticateStatus: () => dispatch(detectAuthStatus()),
    getUAMBusinessFunctions: () => dispatch(getUAMBusinessFunctions()),
    fetchFeatureToggles: () => dispatch(fetchFeatureToggles()),
});

export default connect<IMapStateToProps, IDispatch, {}, IStore>(mapStateToProps, mapDispatchToProps)(Msal);
